import { Post, PostJson } from "../core/Helper";
import { WebSearchHelperService } from "../pages/tools/search-helper";

export class Branch {}

export class BranchService {
  static async GetItem(data, user) {
    let result = await PostJson("/api/branch-new/get-item-new", {
      data,
      user,
    });
    return result ?? null;
  }

  static async GetNewList(data, user) {
    let result = await PostJson("/api/branch-new/getlist", {
      data,
      user,
    });
    return result ?? null;
  }

  static async GetList(params) {
    let result = await Post("api/branch/select", params);
    return (await result.lists) ?? null;
  }

  static async getBranchList() {
    let sql = `select brchid, brchcode, brchname, brchshort
from ba_branch where del_flag='n' order by brchcode`;
    return await WebSearchHelperService.Query(sql);
  }

  static async Delete(params) {
    let result = await Post("api/branch/delete", params);
    return (await result.lists) ?? null;
  }

  static async GetReportStudy(params) {
    let result = await Post("api/branch/getreport-study", params);
    return (await result.lists) ?? null;
  }
}
